import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { api } from '../../services/api'
import type { StampSlot } from '../../services/api'

/**
 * イベント枠 (カードの中のバナー・#2492 ポップアップ・下部の帯) の「押したとき」と計測。
 * 3 か所で同じ動きにするため 1 か所に置く。
 *
 * - 外部サイト (http/https) は別タブ、アプリ内のパス (`/stores/xxx`) はアプリの中で移動。
 *   常に別タブにしていたときは、アプリ内パスで **PWA を出て別タブでアプリが開き直っていた**
 * - 飛び先が無い枠は画像を全画面で開く (#1886 焼き込まれた文字をカード幅では読めない)
 * - 押したら 1 回数える。飛び先の有無にかかわらず **「押した」という関心の表明は同じ** (#1997)
 *
 * **`track=false` (リハーサル中) は数えない。** リハーサルは運営が公開前に見え方を確かめる
 * 画面で、ポップアップは再読み込みのたびに出る。数えると出稿元に返す数字と #2491 の
 * 目標回数に運営の確認ぶんが混ざる。リハーサル中の画面は運営だけが開く (名指しの入口のみ)。
 */

export const isExternalSlotLink = (url?: string): boolean => /^https?:\/\//.test(url || '')

/** 表示回数を 1 回送る (リハーサル中は送らない)。 */
export function recordSlotImpression(slot: StampSlot, track: boolean): void {
  if (track) api.recordSlotImpression(slot.id)
}

/** 押したときの動き。全画面で開く画像は `viewing` に入るので、呼ぶ側が ImageLightbox を出す。 */
export function useOpenSlot(track: boolean) {
  const navigate = useNavigate()
  const [viewing, setViewing] = useState<string | null>(null)
  const open = (slot: StampSlot) => {
    if (track) api.recordSlotClick(slot.id)
    if (!slot.linkUrl) return setViewing(slot.imageUrl)
    if (isExternalSlotLink(slot.linkUrl)) window.open(slot.linkUrl, '_blank', 'noopener,noreferrer')
    else navigate(slot.linkUrl)
  }
  return { open, viewing, closeViewing: () => setViewing(null) }
}
